@defer (when validation) {
    @if (validation) {
        <form class="rounded-b bg-form shadow-md" [ngClass]="{'!bg-transparent !shadow-none' : validation.IsAiValidation}">
            @if (validation.AiButtonId !== 0 && validation.IsAiValidation){
                <div class="flex flex-row flex-wrap px-4 py-3 mt-0 gap-4 bg-yellow-500/10 items-center sm:-mx-5 sm:-mt-5 sm:px-5 sm:pl-10 sm:py-2 sm:gap-2.5 shadow-sm">
                    <bizz-icon iconName="circle-exclamation" class="size-8 sm:size-5 text-yellow-600"></bizz-icon>
                    <div class="flex flex-col w-[calc(100%-48px)] items-start sm:flex-row sm:items-center gap-2 sm:w-auto">
                        <span class="text-sm text-default">{{'PleaseConfirmTheFollowingAI' | translate}}:</span>

                        <div class="flex flex-row items-center gap-2">
                            @for (error of validation.Errors; track $index) {
                                @if ($index < 3) {
                                    <span class="flex flex-row items-center">
                                        <span class="text-sm text-default font-semibold">{{ error.Bookmark }}</span>
                                        @if(error.CollectionFormFieldID){
                                            <bizz-icon (click)="validationLinkClick.emit(error.CollectionFormFieldID)"
                                                       class="h-4 w-4 cursor-pointer text-default ml-2"
                                                       iconName="link-simple"></bizz-icon>
                                        }
                                        @if (($index + 1) < Math.min(3, validation.Errors.length)) {
                                            ,
                                        }
                                    </span>
                                }
                            }
                            @if (validation.Errors.length > 3) {
                                <span class="text-sm text-default font-semibold">, ... ({{ validation.Errors.length }} fields).</span>
                            }
                        </div>

                    </div>

                    <span class="flex justify-end items-center ml-auto sm:pl-5">
                        <button (click)="setAiButtonAllAcceptance()" type="button" class="form-header-button save !bg-yellow-600">
                            <bizz-icon class="size-4 " iconName="circle-check"></bizz-icon>
                            <span>{{'ConfirmAiInput' | translate}}</span>
                        </button>
                    </span>

                </div>
            } @else {
                <div class="h-2 w-full rounded-t bg-red-300" [ngClass]="{'bg-yellow-500/10' : validation.IsAiValidation}"></div>

                <div class="mx-4 my-2 flex items-center gap-2 rounded-t text-red-500">
                    <bizz-icon class="h-4 w-4"
                               iconName="circle-exclamation"></bizz-icon>
                    <span class="text-lg font-bold">{{ "SomeFieldsRequireYourAttention" | translate }}</span>
                </div>

                <div class="mx-4 flex flex-col">
                    <hr class="hidden sm:flex">
                    <div class="my-2 flex flex-col gap-2">
                        @for (error of validation.Errors; track $index) {
                            <div class="flex items-center gap-2">
                                <span class="text-sm text-default">{{ error.Message }}</span>
                                @if(error.CollectionFormFieldID){
                                    <bizz-icon (click)="validationLinkClick.emit(error.CollectionFormFieldID)"
                                    class="h-4 w-4 cursor-pointer text-default"
                                    iconName="link-simple"></bizz-icon>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </form>
    }
}

